import React from "react";

const DocFileIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g id="Group_10367" data-name="Group 10367" transform="translate(-32 -691)">
      <rect
        id="Rectangle_646"
        data-name="Rectangle 646"
        width="32"
        height="32"
        rx="10"
        transform="translate(32 691)"
        fill="#f2f2f7"
      />
      <g id="Page-1" transform="translate(34 694)">
        <g id="icon-54-document" transform="translate(7 3)">
          <path
            id="document"
            d="M16.259,3H8.484A1.485,1.485,0,0,0,7,4.487V21.513A1.482,1.482,0,0,0,8.48,23H19.595a1.48,1.48,0,0,0,1.48-1.475V8.185L16.63,3Zm-.37.741H8.478a.742.742,0,0,0-.737.737V21.522a.742.742,0,0,0,.741.737H19.593a.738.738,0,0,0,.741-.736V8.926H17.369a1.478,1.478,0,0,1-1.48-1.486v-3.7Zm.741.37V7.438a.745.745,0,0,0,.738.747h2.743L16.63,4.111Z"
            transform="translate(-7 -3)"
            fill="#34c759"
            stroke="#34c759"
            strokeWidth="0.5"
            fillRule="evenodd"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default DocFileIcon;
